export default "__VITE_ASSET__DrX044ix__"